import { Action } from '@ngrx/store';
import { FlordersFilter } from '../../interfaces/florders-filter.interface';
import { FlordersTO } from '../../interfaces/florders.interface';
import { Place } from '../../interfaces/place.interface';
import { Definitions } from '../definitions/definitions.interface';

export const RELOCATIONS_SET_FILTER = 'relocations:RELOCATIONS_SET_FILTER';
export const RELOCATIONS_CLEAR_FILTER = 'relocations:RELOCATIONS_CLEAR_FILTER';
export const RELOCATIONS_LOAD = 'relocations:RELOCATIONS_LOAD';
export const RELOCATIONS_LOAD_FAIL = 'relocations:RELOCATIONS_LOAD_FAIL';
export const RELOCATIONS_LOAD_SUCCESS = 'relocations:RELOCATIONS_LOAD_SUCCESS';

export class RelocationsSetFilterAction implements Action {
  readonly type = RELOCATIONS_SET_FILTER;
  logPayload = true;

  constructor(readonly payload: { filter: FlordersFilter }) {}
}

export class RelocationsClearFilterAction implements Action {
  readonly type = RELOCATIONS_CLEAR_FILTER;
  logPayload = true;
}

export class RelocationsLoadAction implements Action {
  readonly type = RELOCATIONS_LOAD;
  logPayload = true;

  constructor(readonly payload?: { filter: FlordersFilter }) {}
}

export class RelocationsLoadSuccessAction implements Action {
  readonly type = RELOCATIONS_LOAD_SUCCESS;

  constructor(readonly payload: { definitions: Definitions; places: Place[]; relocations: FlordersTO }) {}
}

export class RelocationsLoadFailAction implements Action {
  readonly type = RELOCATIONS_LOAD_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export type Actions = RelocationsSetFilterAction | RelocationsClearFilterAction | RelocationsLoadAction | RelocationsLoadSuccessAction | RelocationsLoadFailAction;
